import { useEffect, useState } from "react";
import { Notification } from "react-bulma-components";
import ActivationInfo from "./ActivationInfo";

export default function Ranks() {
    
    const [isLoaded, setIsLoaded] = useState(false);
    const [item, setItem] = useState([]);
    const [yourScore, setYourScore] = useState(null);
    const [msg, setMsg] = useState('Ładuję...');
    const [msgActivation, setMsgActivation] = useState('');
    const [row, setRow] = useState();

    var responseOk = false;
    var responseStatus = 0;
    
    useEffect(() => {
    
    fetch('https://studiotworzenia.pl/score.php', {
        crossDomain: true,
        method: 'GET',
        headers: {'Cache-Control': 'no-store', 'Auth-Code': 'Bearer '+localStorage.getItem('user_code')},
    })
    .then((response) => {
        responseOk = response.ok;
        responseStatus = response.status;
        return response.json();
    })
    .then((result) => {
        if(responseOk){
            if(result.hasOwnProperty('is_banned') && result.is_banned==1 ){
                setYourScore(<Notification color="warning" ><h1 className="is-size-1">🚫</h1>Ukończyłeś grę w podejrzanie krótkim czasie... Zostajesz wykluczony z rankingu. Jeżeli nie oszukiwałeś, skontaktuj się ze stoiskiem JohnnyBros, w celu wyjaśnienia sprawy.</Notification>);
            }
            else if(result.hasOwnProperty('points') && result.hasOwnProperty('user_id')){
                setRow(result.user_id);
                setYourScore(<><p><strong><span className="has-text-success mb-2">Twój wynik to </span>{result.points} pkt.</strong></p></>);
                    console.log(result);
                if( result.is_active == 0)
                    setMsgActivation(<ActivationInfo email={result.email}/>);
            }
            
        }
    });

    fetch('https://studiotworzenia.pl/ranks.php', {
        crossDomain: true,
        method: 'GET',
        headers: {'Cache-Control': 'no-store'},
    })
    .then((response) => {
        responseOk = response.ok;
        responseStatus = response.status;
        return response.json();
    })
    .then((result) => {
        if(responseOk){
            if(responseStatus==201){
                setMsg(<p className="mb-3">Nikt jeszcze nie zapisał się na tablicy rekordów. Bądź pierwszy!</p>);
            }
            else{
                setItem(result);
                setMsg('');
                setIsLoaded(true);
            }
            
        }
        else{
            setMsg(<Notification color="danger" >{result.message}</Notification>);
        }
    });
    }, []);

    if(isLoaded)
    return (
        <>
        {msg}
        {yourScore}
        {msgActivation}
        <h1 className="title mb-2 mt-5">Najlepsze wyniki<br/><span className="is-size-7 has-text-weight-light">tylko potwierdzone konta</span></h1>
        <table id="table-ranks" className="table is-fullwidth">
        <tbody>
        {item.map((score,index) => {
        let active = '';
        if(score.user_id==row)
        active = 'active';
        return(
        <tr key={score.user_id} className={active}><td>{index+1}</td><td className="has-text-left">{score.nick}</td><td>{score.points}</td></tr>);
        })}
        </tbody>
        </table>
        </>
    );
    else
    return(
        <>
        {msg}
        {yourScore}
        {msgActivation}
        </>
    );
}